import axios from "axios";
import { API } from "../Constants";

let isRefreshing = false;
let failedQueue = [];

function miAxios(handleLogout) {

  const instancia = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json"
    }
  })


  instancia.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) { // Asegúrate de que el token exista antes de agregarlo
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
    (error) => {
      console.log(error)
      Promise.reject(error)
    }
  );

  instancia.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      console.log("Error en axios...", error)
      const originalRequest = error.config;

      if (error.response?.status === 401 && !originalRequest._retry) {
        console.log("dio el error 401....")
        if (isRefreshing) {
          try {
            return new Promise((resolve, reject) => {
              failedQueue.push({ resolve, reject, config: originalRequest });
            });
          } catch (queueError) {
            // Manejo de errores si algo sale mal al encolar la promesa
            return Promise.reject(queueError);
          }

        }

        originalRequest._retry = true;
        isRefreshing = true;

        try {

          const response = await axios.get(
            API + "login/refresh-token-prov",
            { withCredentials: true }
          );
          const { accessToken } = response.data;

          localStorage.setItem("token", accessToken);
          instancia.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
          originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;


          processQueue(null, accessToken);

          return instancia(originalRequest);
        } catch (refreshError) {
          processQueue(refreshError, null);
          handleLogout()
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }

      return Promise.reject(error);
    }
  );

  return instancia;

}

function processQueue(error, token = null) {
  failedQueue.forEach(prom => {
    if (error) {
      console.log("error en queue...")
      prom.reject(error);
    } else {
      // Actualiza el header de autorización para la petición encolada
      prom.config.headers["Authorization"] = `Bearer ${token}`;
      // Reintenta la petición encolada
      prom.resolve(axios(prom.config));
    }
  });

  failedQueue = []; // Limpia la cola después de procesarla
}

export default miAxios;

